import type { StepProps } from '../types';
import { CurrencyField } from '../fields';

export default function CreditsStep({ input, onChange }: StepProps) {
  return (
    <div className="space-y-8" data-tour="credits-step">
      <div data-tour="credits-payments">
        <h3 className="text-sm font-semibold mb-4">Payments & Withholding</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <CurrencyField label="Federal Withholding" value={input.federalWithholding} onChange={v => onChange('federalWithholding', v)} hint="1040 line 25d · W-2 box 2" />
          <CurrencyField label="Estimated Tax Payments" value={input.estimatedTaxPayments} onChange={v => onChange('estimatedTaxPayments', v)} hint="1040 line 26" />
          <CurrencyField label="State Withholding" value={input.stateWithholding ?? 0} onChange={v => onChange('stateWithholding', v)} hint="W-2 box 17 · nets against state tax" />
        </div>
      </div>
    </div>
  );
}
